// src/components/RoadmapSection.tsx
import SectionHeading from "./SectionHeading";
import { ROADMAP } from "../data/content.js";

const STATUS_STYLE: Record<string, { bg: string; color: string; border: string; label: string }> = {
  done:     { bg: "rgba(16,185,129,.12)",  color: "#34d399", border: "rgba(16,185,129,.3)",  label: "Completed" },
  active:   { bg: "rgba(124,58,237,.15)",  color: "#a78bfa", border: "rgba(124,58,237,.4)",  label: "In Progress" },
  upcoming: { bg: "rgba(107,104,136,.1)",  color: "var(--muted)", border: "rgba(107,104,136,.2)", label: "Upcoming" },
};

export default function RoadmapSection() {
  return (
    <section style={{ padding: "64px 48px", position: "relative", zIndex: 1 }}>
      <SectionHeading eyebrow="Roadmap" title="What's" accent="Coming" desc="MeeChain development milestones and upcoming features." center />

      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16, position: "relative" }}>
        {/* Connector line */}
        <div style={{
          position: "absolute", top: 28, left: "12.5%", right: "12.5%", height: 1,
          background: "linear-gradient(90deg,rgba(16,185,129,.4),rgba(124,58,237,.5),rgba(107,104,136,.2),rgba(107,104,136,.2))",
          zIndex: 0,
        }} />

        {ROADMAP.map((phase, i) => {
          const ss = STATUS_STYLE[phase.status];
          return (
            <div key={phase.phase} style={{
              background: "var(--bg2)", border: `1px solid ${ss.border}`,
              borderRadius: 12, padding: "20px", position: "relative", zIndex: 1,
            }}>
              {/* Phase number */}
              <div style={{
                width: 36, height: 36, borderRadius: "50%", marginBottom: 12,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontFamily: "var(--display)", fontSize: 15, fontWeight: 700,
                background: ss.bg, border: `1px solid ${ss.border}`, color: ss.color,
              }}>{i + 1}</div>

              <div style={{ fontSize: 10, fontWeight: 700, color: ss.color, letterSpacing: ".1em", textTransform: "uppercase", marginBottom: 2 }}>
                {phase.phase}
              </div>
              <div style={{ fontSize: 16, fontWeight: 700, color: "#fff", marginBottom: 12, fontFamily: "var(--display)" }}>
                {phase.label}
              </div>

              <span style={{ fontSize: 9, fontWeight: 700, padding: "2px 8px", borderRadius: 4, background: ss.bg, color: ss.color, border: `1px solid ${ss.border}`, letterSpacing: ".06em" }}>
                {ss.label}
              </span>

              <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 6 }}>
                {phase.items.map(item => (
                  <div key={item} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12, color: "var(--muted)" }}>
                    <div style={{ width: 5, height: 5, borderRadius: "50%", background: ss.color, flexShrink: 0 }} />
                    {item}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
